import validateRfc from "validate-rfc";
export const isTextEmpty = (string: string) => /^$/g.test(string);

/**
 `isUnderCharactersLimit`receives a string and a  number of characters limit, and return if is inside the limit or not.
  *@param (string) string - the word you want to check
  *@param (number) characters - 1 number above the limit is your max limit is 13, you should put 14
 */

export const isUnderCharactersLimit = (
  string: string,
  characters: number,
): boolean => {
  const regex = new RegExp(`^.{0,${characters}}$`, "u");

  return !regex.test(string);
};

/**
 `isPhoneNumber`receives a string and verify if is a phone number.
  *@param (string) string - the word you want to check
 */

export const isPhoneNumber = (string: string): boolean => {
  const regex = /^\d{10}$/;

  return !regex.test(string);
};

export const isRFC = (string: string): boolean => {
  const response = validateRfc(string, {
    omitVerificationDigit: true,
  });

  return response.isValid;
};

export const isValidTextWithoutSpecialChar = /^[a-zA-Z0-9 áéíóúÁÉÍÓÚñÑ]+$/;

/**
 * Validates whether the given MAC address string is in a correct format.
 * Supported formats: "XX:XX:XX:XX:XX:XX" or "XX-XX-XX-XX-XX-XX", where X is a hexadecimal digit.
 *
 * @param mac - The MAC address string to validate.
 * @returns true if the MAC address is valid; false otherwise.
 */
export function isValidMacAddress(mac: string): boolean {
  // Regular expression for validating MAC addresses in the form:
  // XX:XX:XX:XX:XX:XX or XX-XX-XX-XX-XX-XX
  const macRegex = /^([0-9A-Fa-f]{2}([-:])){5}[0-9A-Fa-f]{2}$/;
  return macRegex.test(mac);
}


/**
 * Validates whether the given email string is in a correct format.
 * This uses a basic regular expression to check the structure of the email.
 *
 * @param email - The email address to validate.
 * @returns true if the email address is valid; false otherwise.
 */
export function isValidEmail(email: string): boolean {
  // A basic regular expression to validate an email address.
  // It checks for at least one character before the '@',
  // at least one character between the '@' and the '.',
  // and at least one character after the '.'.
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}



/**
 * Validates that the input string meets the following criteria:
 * - Minimum length of 4 characters and maximum length of 20 characters.
 * - Must start with '0'.
 * - Contains only the digits 0, 1, 2, and 3.
 *
 * @param input - The string to validate.
 * @returns true if the input meets the criteria; false otherwise.
 */
export function validatePasswordMenu(input: string): boolean {
  // Regular expression breakdown:
  // ^            : Start of the string.
  // 0            : The string must start with the character '0'.
  // [0-3]{3,19}  : After the initial '0', there must be between 3 and 19 characters,
  //                each one being a digit from 0 to 3. This ensures total length between 4 and 20.
  // $            : End of the string.
  const regex = /[0-3]{3,19}$/;
  return regex.test(input);
}


/**
 * Validates that the provided text does not contain any letters.
 *
 * @param text - The string to validate.
 * @returns true if the text does NOT contain any letters; false otherwise.
 */
export function textHasNoLetters(text: string): boolean {
  // This regular expression looks for any letter from a to z (case insensitive).
  const letterRegex = /[a-zA-Z]/;
  return !letterRegex.test(text);
}


/**
 * Validates that a string is a valid IMEI number.
 * A valid IMEI must:
 * - Have exactly 15 numeric digits
 * - Pass the Luhn algorithm validation
 * 
 * @param imei - The IMEI number to validate
 * @returns true if it's a valid IMEI, false otherwise
 */
export function isValidIMEI(imei: string): boolean {
  // Check that it has exactly 15 digits
  if (!/^\d{15}$/.test(imei)) {
    return false;
  }

  // Implement the Luhn algorithm
  let sum = 0;
  let isEven = false;

  // Iterate digits from right to left
  for (let i = imei.length - 1; i >= 0; i--) {
    let digit = parseInt(imei[i]);

    if (isEven) {
      digit *= 2;
      if (digit > 9) {
        digit -= 9;
      }
    }

    sum += digit;
    isEven = !isEven;
  }

  // IMEI is valid if sum is multiple of 10
  return sum % 10 === 0;
}
export function isValidSerialNumber(serialNumber: string): boolean {
  // Check that it has les than 10 digits
  if (serialNumber.length<10) {
    return false;
  }
  // Check that it has more than 50 digits
  if (serialNumber.length>50) {
    return false;
  }
  return true

}
